import {
    getCachedTableDataSlice,
    getCachedTableResultSelector,
} from 'src/hooks/common-data-service/cached-table';

import {entitlementRoleChangeLogStateSelector} from './entitlement-role-change-log-state.slice';

import type {EntitlementRoleLogsCriteria} from '../typedef';
import type {
    CachedTableCacheSelector,
    CachedTableDataSelector,
} from 'src/hooks/common-data-service/cached-table/typedef';
import type {LogHits} from 'src/openapi/admin/models/LogHits';


export const entitlementRoleChangeLogSlice = getCachedTableDataSlice<
    LogHits[],
    undefined,
    undefined,
    EntitlementRoleLogsCriteria
>('entitlementRoleChangeLog');

export const entitlementRoleChangeLogActions = entitlementRoleChangeLogSlice.actions;
const entitlementRoleChangeLogCacheSelector: CachedTableCacheSelector<LogHits[]>
    = state => state.manageEntitlements.entitlementRoleChangeLogReducer.events.cache;
export const entitlementRoleChangeLogDataSelector: CachedTableDataSelector<LogHits[]>
    = state => state.manageEntitlements.entitlementRoleChangeLogReducer.events;
export const entitlementRoleChangeLogResultSelector = getCachedTableResultSelector(
    entitlementRoleChangeLogCacheSelector,
    entitlementRoleChangeLogStateSelector,
);
